import SandeepKumarShukla from "../../assets/faculty/sandeep-kumar-shukla.webp";
import Ekta from "../../assets/faculty/ekta-1.webp";
import nivruti1 from "../../assets/faculty/nivruti1.webp";
import Ravindran from "../../assets/faculty/ravindran1.webp";
import venkat from "../../assets/faculty/Venkat.webp";
import Rajgopal from "../../assets/faculty/Rajgopal.webp";
import Ramesh from "../../assets/faculty/ramesh.webp";
import RaghubabuReddyY from "../../assets/faculty/team faculty/Raghubabu-Reddy-Y.webp";
import Deva from "../../assets/faculty/deva.webp";

const facultyData = [
  {
    id: 1,
    name: "Prof Sandeep Kumar Shukla",
    role: "Professor & Director, Ph.D (State University of New York at Albany)",
    image: SandeepKumarShukla,
  },
  {
    id: 2,
    name: "Dr Ekta Kapoor",
    role: "Member, Mission Director NM-ICPS, DST",
    image: Ekta,
  },
  {
    id: 3,
    name: "Nivruti Rai",
    role: "Member, MD and CEO Invest India",
    image: nivruti1,
  },
  {
    id: 4,
    name: "Prof B. Ravindran",
    role: "Member, Head, Robert Bosch Centre for Data Science and AI Professor, IIT Madras",
    image: Ravindran,
  },
  {
    id: 5,
    name: "Dr Venkat Padmanabhan",
    role: "Member, Managing Director, Microsoft Research India",
    image: venkat,
  },
  {
    id: 6,
    name: "Dr Rajgopal Srinivasan",
    role: "Member, Distinguished Chief Scientist, TCS",
    image: Rajgopal,
  },
  {
    id: 7,
    name: "Prof Ramesh Loganathan",
    role: "Member, Professor of Practice, Co-innovations, IIIT Hyderabad",
    image: Ramesh,
  },
  {
    id: 8,
    name: "Prof Raghubabu Reddy Y",
    role: "Associate Professor, Ph.D (Colorado State University)",
    image: RaghubabuReddyY,
  },
  {
    id: 9,
    name: "Prof U. Deva Priyakumar",
    role: "Professor, Dean RnD, Ph.D (Pondicherry University)",
    image: Deva,
  },
];

export default facultyData;